module.exports = __webpack_public_path__ + "assets/plus-call.a458d37d.svg";